import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {distinctUntilChanged, pluck} from 'rxjs/operators';

export interface ChangesTabStoreInterface {
  reload: boolean;
  [name: string]: boolean;
}

const state = {
  reload: false,
  action: false
};

@Injectable({
  providedIn: 'root'
})
export class ChangesTabStoreService {
  private subject = new BehaviorSubject<ChangesTabStoreInterface>(state);
  private store = this.subject.asObservable().pipe(distinctUntilChanged());

  get value() {
    return this.subject.value;
  }

  select<T>(name: string): any {
    return this.store.pipe(pluck(name));
  }

  set(name: string, stateValue: any) {
    if (name === 'actions' && this.checkForChanges(stateValue)) {
      this.subject.next({reload: true});
    }
  }

  checkForChanges(actionsCopy) {
    const storiesPresent = action => !!(action.storyAttachments || []).length;
    const requirementsPresent = action => !!(action.requirementAttachments || []).length;
    const changesPresent = action => !!(storiesPresent(action) || requirementsPresent(action));

    const storiesActions = activity =>
      !!(activity.deleteStoryAttachment || activity.createStoryAttachment);
    const requirementsActions = activity =>
      !!(activity.deleteRequirementAttachment || activity.createRequirementAttachment);
    const activityAction = action => !!action.deleteActivity;
    const checkActionsPull = action =>
      !!(activityAction(action) || storiesActions(action) || requirementsActions(action));

    const actionsArray = Array.isArray(actionsCopy) ? actionsCopy : [actionsCopy];

    return actionsArray.reduce((accum, item: any) => {
      if (item.group && Array.isArray(item.group)) {
        item.group.forEach(itemGroup => {
          accum = accum || checkActionsPull(itemGroup);

          if (itemGroup.createActivity) {
            accum = accum || changesPresent(itemGroup.createActivity);
          }
        });
      } else {
        accum = accum || checkActionsPull(item);

        if (item.createActivity) {
          accum = accum || changesPresent(item.createActivity);
        }
      }

      return accum;
    }, false);
  }
}
